import React from 'react'
import homesvideo from '../video/VID-20241013-WA0000.mp4'

export default function About({ id }) {
    return (
        <>
            <div id={ id } className=' m-4 sm:m-8 md:m-12 lg:m-16 bg-gray-100 shadow-xl'>
                
                {/* Heading Section */}
                <div className='heading flex flex-col items-center justify-center gap-5 px-2 sm:px-8 md:px-16 pt-8'>
                    <div className='w-full flex items-center justify-center gap-5'>
                        <div className='h-2 w-[8%] sm:w-[15%] lg:w-[18%] border-b-[2px] border-black'></div>
                        <h2 className=' text-xl sm:text-3xl md:text-4xl'>About Us</h2>
                        <div className='h-2 w-[8%] sm:w-[15%] lg:w-[18%] border-b-[2px] border-black'></div>
                    </div>
                </div>

                {/* Content Section */}
                <div className='w-full p-6 sm:p-8 md:p-12 lg:p-16 shadow-sm flex flex-col lg:flex-row gap-10 rounded-lg'>
                    
                    {/* Text Section */}
                    <div className='w-full lg:w-1/2 flex flex-col gap-5'>
                        <h3 className='text-2xl sm:text-3xl md:text-4xl font-["robecha-daniera"]'>
                            Homeland's Upcoming Commercial Project
                        </h3>
                        <p className='text-base sm:text-lg md:text-xl'>
                            At Homeland, we take pride in shaping innovative spaces that drive progress. Our latest venture, a 15-acre commercial township, is a testament to our commitment to quality, sustainability, and community-driven growth. With a massive 1000 ft frontage, this project is strategically located to maximize visibility and accessibility, offering a unique opportunity for businesses to thrive in a dynamic, high-traffic environment.
                            <br /><br />
                            Designed with modern infrastructure, ample space, and cutting-edge amenities, Homeland's commercial township is poised to become a landmark destination for commerce, trade, and entrepreneurship. Whether you're a startup, established enterprise, or retail business, we have crafted an ecosystem where your business can flourish.
                            <br /><br />
                            Join us in creating a business hub that transforms the landscape of opportunity.
                        </p>
                    </div>

                    {/* Video Section */}
                    <div className='w-full lg:w-1/2 rounded-lg shadow-2xl overflow-hidden h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh]'>
                        {/* Video element (currently commented out) */}
                        <video src={homesvideo} autoPlay loop muted className='h-full w-full object-cover' />
                    </div>
                </div>
            </div>
        </>
    )
}
